import React from 'react';

import { Select, SelectItem } from '@zapier/design-system';

import { buildSidebarVersionDropdownItems } from '../utils';

import type { SemVer } from 'app/developer-v3/types/version';

type Props = {
  onChange: (version: SemVer) => {};
  version?: SemVer;
  versions: SemVer[];
};

const Versions = ({ onChange, version, versions }: Props) => {
  const items = buildSidebarVersionDropdownItems(versions);

  return (
    <Select
      isLabelHidden={true}
      label="Versions"
      onChange={key => onChange(key as SemVer)}
      selectedKey={version ?? null}
    >
      {items.map(item => (
        <SelectItem key={item.value} value={item.value}>
          {item.label}
        </SelectItem>
      ))}
    </Select>
  );
};

Versions.defaultProps = {
  versions: [],
};

export default Versions;
